import React, { useState } from "react";
import { Modal, Box, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  modalImage: {
    maxWidth: "80vw",
    maxHeight: "80vh",
    display: "block",
    margin: "auto"
  },
  modalNavBtn: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-5%)",
    background: "#fff",
    borderRadius: "50%",
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
    zIndex: 2
  },
  modalCloseBtn: {
    position: "absolute",
    top: 16,
    right: 16,
    background: "#fff",
    border: "1px solid black",
    borderRadius: "50%",
    zIndex: 3
  },
  modalBox: {
    position: "relative",
    outline: "none"
  }
};

interface ImageListModalProps {
  images: string[];
  initialIndex?: number;
  open: boolean;
  onClose: () => void;
}

const ImageListModal: React.FC<ImageListModalProps> = ({
  images,
  initialIndex = 0,
  open,
  onClose
}) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  React.useEffect(() => {
    if (open) setCurrentIndex(initialIndex);
  }, [open, initialIndex]);

  if (!images || images.length === 0) return null;

  const handlePrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        width="100vw"
        sx={modalStyle.modalBox}
      >
        <IconButton
          onClick={handlePrev}
          sx={{ ...modalStyle.modalNavBtn, left: 32 }}
          aria-label="Previous"
        >
          <ArrowBackIosNewIcon />
        </IconButton>
        <img
          src={images[currentIndex]}
          alt={`attachment-${currentIndex + 1}`}
          style={modalStyle.modalImage}
        />
        <IconButton
          onClick={handleNext}
          sx={{ ...modalStyle.modalNavBtn, right: 32 }}
          aria-label="Next"
        >
          <ArrowForwardIosIcon />
        </IconButton>
        <IconButton
          onClick={handleClose}
          sx={modalStyle.modalCloseBtn}
          aria-label="Close"
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Modal>
  );
};

export default ImageListModal;